module.exports = __webpack_public_path__ + "img/44_15.4fee7bed.png";